import { render, staticRenderFns } from "./projectInside.vue?vue&type=template&id=e0c8a008&scoped=true&"
import script from "./projectInside.vue?vue&type=script&lang=js&"
export * from "./projectInside.vue?vue&type=script&lang=js&"
import style0 from "./projectInside.vue?vue&type=style&index=0&id=e0c8a008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c8a008",
  null
  
)

export default component.exports